import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type PageSectionId = Branded<string, "PageSectionId">;
const {
    factory: pageSectionIdFactory,
    assert: isPageSectionId,
    zodSchema: pageSectionIdZodSchema,
} = genericId<PageSectionId>("page_section__");

export { isPageSectionId, pageSectionIdFactory, pageSectionIdZodSchema };
export type { PageSectionId };
